<div class="dialog">
  <div class="dialog-background" (click)="close()"></div>
  <div class="dialog-content">
    <h2>{{ 'account.reminder.h2' | translate }}</h2>
    <p>
      @if (!useAutoident) {
        {{ 'account.reminder.desc' | translate }}
      } @else {
        {{ 'account.reminder.autoident' | translate }}
      }
    </p>
    <p *ngIf="isBankHoliday" class="holiday-warning">{{ 'account.reminder.bankHoliday' | translate }}</p>
    <div class="flex-row picker-box">
      <div class="flex-col-7 flex-col-sm-12">
        <div class="day-picker">
          <p>{{ 'account.reminder.date' | translate }}</p>
          <span *ngIf="isPast()" (click)="otherDay(-1)" class="icon-i-arrow-back fly_left"></span>
          <span class="icon-i-calendar"></span>
          <span>{{ day }}</span>
          <span *ngIf="isFar()" (click)="otherDay(1)" class="icon-i-arrow-forward fly_right"></span>
        </div>
      </div>
      <div class="flex-col-5 flex-col-sm-12">
        <div class="time-picker">
          <p>{{ 'account.reminder.time' | translate }}</p>
          <input
            (input)="validateTime()"
            (change)="trackActivity('[Button] Change reminder time')"
            #reminderTime
            type="time"
            id="appt"
            name="appt"
            min="08:00"
            max="00:00"
            value="{{ initialHour }}"
            required
          />
        </div>
      </div>
    </div>
    <div class="flex-col-12" *ngIf="!validTime">
      <p class="error" *ngIf="!showPastTimeError">{{ 'account.reminder.error' | translate }}</p>
      <p class="error" *ngIf="showPastTimeError">{{ 'account.reminder.error_past' | translate }}</p>
    </div>
    <div class="ui-button-group reverse">
      <button (click)="close()" class="ui-button secondary">{{ 'account.reminder.cta_no' | translate }}</button>
      <button (click)="save()" class="ui-button" [disabled]="!validTime">
        {{ 'account.reminder.cta_set' | translate }}
      </button>
    </div>
  </div>
</div>
